import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold mb-2">Welcome to ProjectBQO</h1>
      <p className="text-gray-600">Use the navigation to create a lobby or view your existing lobbies.</p>
    </div>
  );
};

export default Dashboard;
